import type { RouteObject } from 'react-router'

import { path } from '../../../routes/paths'
import { SupportLayout } from './SupportLayout'

export const supportRoutes: RouteObject[] = [
  {
    element: <SupportLayout />,
    children: [
      {
        index: true,
        lazy: () => import('@features/support/routes/SupportOperationsList')
      },
      {
        path: path.supportVerifyEmail,
        lazy: () => import('@features/support/routes/SupportVerifyEmail')
      },
      {
        path: path.supportCreateDealerOrg,
        lazy: () => import('@features/support/routes/SupportCreateDealerOrg')
      }
    ]
  }
]
